/** 워크스페이스 스코프 학교 데이터 React Query 키 팩토리 */

export const schoolKeys = {
  all: (workspaceId: string) => ['school', workspaceId] as const,

  annualTimetableCells: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string
  ) => ['school', workspaceId, 'annualTimetableCells', academicYear, termNumber, gradeId] as const,

  programProgressCells: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string
  ) => ['school', workspaceId, 'programProgressCells', academicYear, termNumber, gradeId] as const,

  programScopedRows: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string
  ) => ['school', workspaceId, 'programScopedRows', academicYear, termNumber, gradeId] as const,

  programScopedContentRows: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string,
    scopeType: string,
    scopeKey: string
  ) =>
    [
      'school',
      workspaceId,
      'programScopedContentRows',
      academicYear,
      termNumber,
      gradeId,
      scopeType,
      scopeKey,
    ] as const,

  programFixedRows: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string
  ) => ['school', workspaceId, 'programFixedRows', academicYear, termNumber, gradeId] as const,

  annualProgressMeta: (workspaceId: string, academicYear: number, termNumber: number, gradeId: string) =>
    ['school', workspaceId, 'annualProgressMeta', academicYear, termNumber, gradeId] as const,

  calendarDays: (workspaceId: string, from: string, to: string) =>
    ['school', workspaceId, 'calendarDays', from, to] as const,

  annualTimetableWeekMemos: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeIdsKey: string
  ) => ['school', workspaceId, 'annualTimetableWeekMemos', academicYear, termNumber, gradeIdsKey] as const,

  gradeTrackSections: (workspaceId: string) => ['school', workspaceId, 'gradeTrackSections'] as const,

  annualProjectPrograms: (workspaceId: string, academicYear: number, gradeId: string) =>
    ['school', workspaceId, 'annualProjectPrograms', academicYear, gradeId] as const,

  presentationOwnerStats: (workspaceId: string, ownerKeysSignature: string) =>
    ['school', workspaceId, 'presentationOwnerStats', ownerKeysSignature] as const,

  recordAiFeedbacks: (workspaceId: string, gradeId: string) =>
    ['school', workspaceId, 'recordAiFeedbacks', gradeId] as const,

  annualBehaviorNotes: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string
  ) => ['school', workspaceId, 'annualBehaviorNotes', academicYear, termNumber, gradeId] as const,

  annualPresentationAudit: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string
  ) => ['school', workspaceId, 'annualPresentationAudit', academicYear, termNumber, gradeId] as const,

  programPresentationAudit: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string,
    scopeSignature: string
  ) => ['school', workspaceId, 'programPresentationAudit', academicYear, termNumber, gradeId, scopeSignature] as const,

  weeklyLearningGuideNotes: (
    workspaceId: string,
    academicYear: number,
    termNumber: number,
    gradeId: string
  ) => ['school', workspaceId, 'weeklyLearningGuideNotes', academicYear, termNumber, gradeId] as const,

  weeklyLearningGuideTrackColors: (workspaceId: string, academicYear: number, gradeId: string) =>
    ['school', workspaceId, 'weeklyLearningGuideTrackColors', academicYear, gradeId] as const,
};

export function isSchoolScopedQueryKey(queryKey: readonly unknown[]): boolean {
  return Array.isArray(queryKey) && queryKey[0] === 'school';
}

/** 사용자 스코프 ToDo·예산 노트 React Query 키 팩토리 */
export const noteKeys = {
  all: (userId: string) => ['note', userId] as const,
  todoWorkspace: (userId: string, noteWorkspaceId: string | null) =>
    ['note', userId, 'todo', noteWorkspaceId ?? 'account'] as const,
  budgetWorkspace: (userId: string, noteWorkspaceId: string | null) =>
    ['note', userId, 'budget', noteWorkspaceId ?? 'account'] as const,
};

export function isNoteScopedQueryKey(queryKey: readonly unknown[]): boolean {
  return Array.isArray(queryKey) && queryKey[0] === 'note';
}
